import type { ChatDialogFilterOption } from './types';

/** Вкладки доступной переписки */
export const chatDialogFilterOptions: readonly ChatDialogFilterOption[] = [
    {
        value: 'all',
        label: 'Все',
        title: 'Все доступные переписки'
    },
    {
        value: 'unread',
        label: 'Ждут',
        title: 'Есть непрочитанные сообщения'
    },
];
